module.exports = __webpack_public_path__ + "static/media/Tanzania_flag.05284b3e.svg";